var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, IconButton, PlusIcon, TagInputField, translate, } from '@lucidlink/uicore';
import { useFormRoot } from '@lucidlink/uicore/form-builder';
import { composeValidators } from '@lucidlink/uicore/form-builder/services';
import { PII_BLOCK_CLASS } from '#constants';
import { useAddEmailsToGuestLink } from '../../../../query-hooks/mutations/useAddEmailsToGuestLink';
import { areGuestLinkEmailsValid, guestLinkEmailsCountValidation, guestLinkEmailValidation, guestLinkEmailValidationRules, } from '../../../../services/validation';
const FIELD_NAME = 'emails';
export const AddGuestForm = ({ filespaceId, guestLinkId, workspaceId, }) => {
    _react_refresh_temp_2();
    const { errors, formData, methods } = useFormRoot();
    const { isPending, mutate: addEmails } = useAddEmailsToGuestLink({
        filespaceId,
        workspaceId,
    });
    const fieldErrors = errors?.[FIELD_NAME];
    const composedEmailValidator = useMemo(() => composeValidators(guestLinkEmailValidation, guestLinkEmailsCountValidation), []);
    const clientErrorMessage = useMemo(() => {
        if (fieldErrors?.some((error) => error.isServerError !== undefined)) {
            return '';
        }
        return translate('There are some issues with the emails you have provided. Hover over each for more details.');
    }, [fieldErrors]);
    const isAddGuestsButtonDisabled = !formData.emails?.length || !areGuestLinkEmailsValid(formData.emails);
    const handleAddGuests = () => {
        const emails = formData.emails;
        if (!emails?.length || !areGuestLinkEmailsValid(emails)) {
            return;
        }
        addEmails({ guestLinkId, emails }, {
            onSuccess: () => {
                methods.setFieldsValue({ [FIELD_NAME]: [] });
            },
        });
    };
    return (_jsxs(Box, { align: "start", gap: "s", padding: "xs", children: [_jsx(TagInputField, { "aria-label": translate('Type email addresses to add guests'), className: PII_BLOCK_CLASS, clientErrorMessage: clientErrorMessage, "data-testid": "guest-emails-input", getTagErrorText: ({ code }) => translate(code), id: FIELD_NAME, name: FIELD_NAME, placeholder: translate('Type email addresses to add guests'), rules: guestLinkEmailValidationRules(), validator: composedEmailValidator }), _jsx(IconButton, { "aria-label": translate('Add guests'), "data-testid": "add-guests-button", disabled: isAddGuestsButtonDisabled, Icon: PlusIcon, isLoading: isPending, kind: "primary", onClick: handleAddGuests, size: "big" })] }));
};
_react_refresh_temp_1 = AddGuestForm;
$RefreshReg$(_react_refresh_temp_1, "AddGuestForm");
_react_refresh_temp_2(AddGuestForm, "hXhCSnPY7vG79ZXN/0hS9IDffMA=", false, () => [useFormRoot, useAddEmailsToGuestLink]);
